<style scoped>
	.hnx-icon {
		display: inline-block;
	}

	.hidden {
		display: none !important;
	}
</style>

<template>
	<i :class="`${set} ${set}-${iconName} ${iconClass} hnx-icon`" :style="style">
		<span class="hidden" ref="iconName">
			<slot></slot>
		</span>
	</i>
</template>

<script>
export default {
	props: {
		set: {
			type: String,
			default: 'mdi'
		},
		
		iconClass: {
			type: String,
			default: ''
		},

		scale: {
			type: [String, Number],
			default: '1.25'
		}
	},
	
	data() {
		return {
			iconName: '',
		};
	},
	
	computed: {
		style() {
			return {
				transform: `scale(${this.scale})`
			};
		}
	},

	mounted() {
		try {
			this.iconName = this.$refs.iconName.innerText.trim();
		} catch (err) {
			this.iconName = '';
		}
	}
};
</script>
